import React, { Component } from 'react'
import { Form, TimePicker, Checkbox } from 'antd';
import { InputNumber } from '../../../../../components/common/input-number';

export class DespositAndTerm extends Component {

    render() {

        const { unlimitEdit, isOwner, typeOption } = this.props;
        return <>
            <div className="title-contract">10. Đặt cọc đảm bảo và thời hạn thanh toán</div>
            <Form.Item
                wrapperCol={15}
                name={'deposit'}
                label={<div className="label-special"><div className="plus">+</div><div> Số tiền đặt cọc:</div></div>}>
                <InputNumber className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''} is_money disabled={!unlimitEdit || (typeOption !== 'create_new' && !isOwner)} suffix={"VNĐ"} />
            </Form.Item>
            <Form.Item
                name={'payment_term'}
                wrapperCol={15}
                label={<div className="label-special"><div className="plus">+</div><div>Thời hạn thanh toán:</div></div>}
                rules={[{
                    required: true,
                    message: `Vui lòng nhập Thời hạn thanh toán`
                }]
                }
            >
                <InputNumber className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''} disabled={!unlimitEdit || (typeOption !== 'create_new' && !isOwner)} suffix={'ngày'} />
            </Form.Item>
            <Form.Item
                wrapperCol={15}
                label={<div className="label-special"><div className="plus">+</div><div>Trả xe báo trước:</div></div>}
                name={'days_inform_before_return_vehicle'}
                rules={[
                    {
                        required: true,
                        message: `Vui lòng nhập số ngày báo trước!`,
                    }
                ]}>
                <InputNumber disabled={!unlimitEdit} suffix={"ngày"} />
            </Form.Item>
        </>
    }
}
